module.exports = __webpack_public_path__ + "img/now.4eb6c218.png";